import React, { useEffect, useState } from "react";
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom'
import Profile from "./Profile";
import Acceuil from "./Acceuil";
import Series from "./Series";
import Films from "./Films";
import MaListe from "./MaListe";
import AjouterMedia from "./AjouterMedia";
import Video from "./Video";
import Nouveautes from "./Nouveautes";
import Test from "./test";
import ProfileDetails from "./ProfileDetails";
import Inscription from "./Inscription";
import Connexion from "./Connexion";
import CreateProfile from "./CreateProfile";
import PrivateRoute from "./Private";
import SearchMedia from "./SearchMedia";
import ProfileList from "./lists/ProfileList";
import InfosMedia from "./InfosMedia";
import Header from "./Header";





function Navigation() {
  const [appLoaded, setAppLoaded] = useState(false);

  useEffect(() => {
    // Simulez un chargement de 3 secondes avant de marquer l'application comme chargée
    const timeoutId = setTimeout(() => {
      setAppLoaded(true);
    }, 3000);

    return () => clearTimeout(timeoutId);
  }, []);

  const handleNavigation = (event) => {
    // Empêchez la navigation si l'application n'est pas encore chargée
    if (!appLoaded) {
      event.preventDefault();
    }
  };
  return (
    <>

      <Router>
        <Header />

        <Routes>
          <Route path="/" element={<PrivateRoute element={<Profile />} redirectTo="/connexion" />} onClick={handleNavigation}></Route>
          <Route path="/acceuil" element={<PrivateRoute element={<Acceuil />} redirectTo="/connexion" />} onClick={handleNavigation}></Route>
          <Route path="/series" element={<PrivateRoute element={<Series />} redirectTo="/connexion" />} onClick={handleNavigation}></Route>
          <Route path="/films" element={<PrivateRoute element={<Films />} redirectTo="/connexion" />} onClick={handleNavigation}></Route>
          <Route path="/maListe" element={<PrivateRoute element={<MaListe />} redirectTo="/connexion" />}></Route>
          <Route path="/AjouterMedia" element={<PrivateRoute element={<AjouterMedia />} redirectTo="/connexion" />}></Route>
          <Route path="/video/:nom/:seasonIndex/:episodeIndex" element={<PrivateRoute element={<Video />} redirectTo="/connexion" />}></Route>
          <Route path="/video/:nom" element={<PrivateRoute element={<Video />} redirectTo="/connexion" />}></Route>
          <Route path="/news" element={<PrivateRoute element={<Nouveautes />} redirectTo="/connexion" />}></Route>
          <Route path="/test" element={<PrivateRoute element={<Test />} redirectTo="/connexion" />}></Route>
          <Route path="/profile/:profileId" element={<PrivateRoute element={<ProfileDetails />} redirectTo="/connexion" />}></Route>
          <Route path="/recherche" element={<PrivateRoute element={<SearchMedia />} redirectTo="/connexion" />}></Route>
          {/* <Route path="/inscription" element={<Inscription />}></Route> */}
          <Route path="/connexion" element={<Connexion />}></Route>
          <Route path="/liste_profile/:id" element={<PrivateRoute element={<ProfileList />} redirectTo="/connexion" />}></Route>
          <Route path="/create_profile/:id" element={<PrivateRoute element={<CreateProfile />} redirectTo="/connexion" />}></Route>
          <Route path="/infos/:nom" element={<PrivateRoute element={<InfosMedia />} redirectTo="/connexion" />}></Route>
        </Routes>
      </Router>
    </>
  )
}

export default Navigation;